var map = {
	"./5_rabbit.mp3": "df66",
	"./6_bear.mp3": "31a1",
	"./7_mole.mp3": "4815",
	"./M_Brilliant.mp3": "5c55",
	"./M_Excellent.mp3": "eab9",
	"./M_Fantastic.mp3": "46dd",
	"./M_Great.mp3": "7e49",
	"./M_Perfect.mp3": "43d15",
	"./M_Think again.mp3": "b24c",
	"./M_Try again.mp3": "d6b5",
	"./M_Very good.mp3": "003c",
	"./M_Well done.mp3": "a230",
	"./M_Work harder.mp3": "f5f6",
	"./click.mp3": "89a9",
	"./false.mp3": "ad18",
	"./true.mp3": "a7ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1840";